module.exports = __webpack_public_path__ + "img/skinbox-spring-white.791b5464.png";